import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
declare var $: any

@Component({
  selector: 'app-contact-report',
  templateUrl: './contact-report.component.html',
  styleUrls: ['./contact-report.component.scss']
})
export class ContactReportComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    let thisTs = this

    var table1 = $('#example1').DataTable();
    var table2 = $('#example2').DataTable();

    $('#example1 tbody').on('click', 'tr', function () {
      var data = table1.row(this).data();
      //alert('You clicked on ' + data[0] + '\'s row');
      thisTs.router.navigate(['/detail'])
    });

    $('#example2 tbody').on('click', 'tr', function () {
      var data = table2.row(this).data();
      //alert('You clicked on ' + data[0] + '\'s row');
      thisTs.router.navigate(['/detail'])
    });
  }

  clearActionActive() {
    $(".action-menu").each(function () {
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  create(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")

    $("#createModal").modal('show')
  }
  delete(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
    $("#deleteModal").modal('show')
  }
  forward(event: any) {
    this.clearActionActive()
    event.target.classList.add("active")
    $("#forwardModal").modal('show')
  }

  confirmCreate() {
    $("#createModal").modal('hide')
  }

  confirmForward() {
    $("#forwardModal").modal('hide')
  }

  confirmDelete() {
    $("#deleteModal").modal('hide')
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-report/contact-report.component.ts